var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewsTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 6,
    fill: "#262551"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_667_11079)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.6111 16.3056C26.6111 21.9972 21.9972 26.6111 16.3056 26.6111C10.614 26.6111 6 21.9972 6 16.3056C6 10.614 10.614 6 16.3056 6C21.9972 6 26.6111 10.614 26.6111 16.3056ZM16.6749 13.608C15.6725 14.0249 13.6692 14.8879 10.6649 16.1968C10.177 16.3908 9.92148 16.5806 9.89822 16.7661C9.8589 17.0798 10.2517 17.2033 10.7865 17.3714C10.8592 17.3943 10.9346 17.418 11.0119 17.4431C11.5381 17.6142 12.2459 17.8143 12.6138 17.8222C12.9476 17.8294 13.3201 17.6918 13.7314 17.4094C16.5384 15.5146 17.9874 14.5569 18.0784 14.5362C18.1426 14.5217 18.2315 14.5034 18.2917 14.5569C18.352 14.6105 18.3461 14.7119 18.3397 14.7391C18.3008 14.905 16.7591 16.3383 15.9613 17.08C15.7126 17.3112 15.5361 17.4753 15.5001 17.5127C15.4193 17.5966 15.3369 17.676 15.2578 17.7523C14.769 18.2235 14.4024 18.5769 15.2781 19.154C15.6989 19.4313 16.0357 19.6606 16.3716 19.8894C16.7385 20.1393 17.1045 20.3885 17.578 20.6989C17.6986 20.7779 17.8138 20.8601 17.926 20.9401C18.353 21.2445 18.7366 21.5179 19.2105 21.4743C19.4859 21.449 19.7703 21.1901 19.9148 20.4178C20.2562 18.5927 20.9273 14.6382 21.0824 13.0086C21.096 12.8658 21.0789 12.6831 21.0651 12.6029C21.0514 12.5227 21.0227 12.4084 20.9185 12.3238C20.795 12.2236 20.6044 12.2025 20.5191 12.204C20.1315 12.2108 19.5368 12.4176 16.6749 13.608Z",
    fill: "#8E97CD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_667_11079"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20.6111,
    height: 20.6111,
    fill: "white",
    transform: "translate(6 6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewsTelegram);
export default __webpack_public_path__ + "static/media/newsTelegram.a6e151118195dea4bdadb6a8ac1e8e8b.svg";
export { ForwardRef as ReactComponent };